import { StyledIssueRow, StyledIssuesList } from './IssuesList.style';
import { StyledLink } from '../../../../ResourceAllocationOverview.style';
import _ from 'lodash';
import { mapPmProviderToViewer } from 'common/hooks/pm/usePmViewer/usePmViewer.utils';

const TOP_ISSUES_IN_VIEW = 5;
const ISSUE_NAME_MAX_LENGTH = 20;

const IssueRow = ({ issue }) => {
  const ftePercentage =
    _.get(issue, 'fte_p', 0) || _.get(issue, 'investment_p') || 0;
  const roundFtePercentage = _.round(ftePercentage, 2);
  const issueUrl = _.get(issue, 'url');
  const issueKey = _.get(issue, 'key') || '';
  const issueName = _.get(issue, 'name') || '';
  const issueTitle = `${issueKey} ${issueName}`;

  const isIssueTitleTooLong = issueTitle.length > ISSUE_NAME_MAX_LENGTH;
  const issueTitleInView = isIssueTitleTooLong
    ? `${issueTitle.substring(0, ISSUE_NAME_MAX_LENGTH)}...`
    : issueTitle;

  return (
    <StyledIssueRow>
      <div className='issue-fte'>{roundFtePercentage}%</div>
      <div
        className='issue-key'
        title={isIssueTitleTooLong ? issueTitle : null}
      >
        {issueUrl ? (
          <StyledLink target='_blank' href={issueUrl}>
            {issueTitleInView}
          </StyledLink>
        ) : (
          <span>{issueTitleInView}</span>
        )}
      </div>
    </StyledIssueRow>
  );
};

const IssuesList = ({ pointData, resourceType }) => {
  const totalIssues =
    _.get(pointData, 'epics.total') ||
    _.get(pointData, 'associated_entities.total') ||
    0;
  const topIssues =
    _.get(pointData, 'epics.top_epics') ||
    _.get(pointData, 'associated_entities.top_associated_entities') ||
    [];
  const topIssuesInView = topIssues.slice(0, TOP_ISSUES_IN_VIEW);
  const orderedTopIssues = _.orderBy(
    topIssuesInView,
    epic => epic.fte_p,
    'desc'
  );

  const pmViewer = mapPmProviderToViewer(resourceType.pmProvider);

  return (
    <StyledIssuesList>
      <div className='header'>
        {totalIssues} {pmViewer.oldIssueParent1.plural} in this{' '}
        {resourceType.singleName}
      </div>
      <div className='main'>
        {orderedTopIssues.map((issue, idx) => (
          <IssueRow key={idx} issue={issue} />
        ))}
      </div>
    </StyledIssuesList>
  );
};

export default IssuesList;
